import request from './services/axios.js'

export default {
  login: (params) => {
    return request({
      params,
      url: '/ebook/getUserInfo',
      method: 'get'
    })
  },
  getUserInfo: () => {
    return request({
      url: '/user/userInfo.do',
      method: 'get'
    })
  },
  modifyName: (userName) => {
    return request({
      url: '/user/modifyName.do?userName=' + userName,
      method: 'post'
    })
  },
  modifyHeadPicture: (param) => {
    return request({
      url: '/user/modifyHeadPicture.do',
      data: param,
      method: 'post'
    })
  },
  modifyPassword: (param) => {
    return request({
      url: '/user/modifyPassword.do?oldPassword=' + param.oldPassword + '&newPassword=' + param.newPassword,
      method: 'post'
    })
  }
}
